"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApolloClient = void 0;
var client_1 = require("@apollo/client");
var retry_1 = require("@apollo/client/link/retry");
var moment_1 = __importDefault(require("moment"));
var index_1 = require("../../index");
var apolloClient;
function getApolloClient() {
    if (!apolloClient) {
        apolloClient = initApolloClient();
    }
    return apolloClient;
}
exports.getApolloClient = getApolloClient;
function initApolloClient() {
    var _a;
    var httpLink = new client_1.HttpLink({ uri: index_1.PLATFORM_URI + ((_a = process.env.REACT_APP_GRAPHQL_ENDPOINT) !== null && _a !== void 0 ? _a : '/api/graphql'), fetch: fetch, credentials: 'include' });
    return new client_1.ApolloClient({
        link: client_1.ApolloLink.from([new retry_1.RetryLink(), httpLink]),
        cache: new client_1.InMemoryCache({
            typePolicies: {
                ChatChannel: {
                    keyFields: ['name'],
                    fields: {
                        messages: {
                            keyArgs: false,
                            merge: function (existing, incoming) {
                                if (existing === void 0) { existing = []; }
                                if (incoming === void 0) { incoming = []; }
                                return __spreadArray(__spreadArray([], incoming, true), existing, true).sort(function (m1, m2) { return (0, moment_1.default)(m1.date).unix() - (0, moment_1.default)(m2.date).unix(); })
                                    .filter(function (message, index, messages) { return index === 0 || message.id !== messages[index - 1].id; });
                            }
                        }
                    }
                },
                Message: {
                    keyFields: false
                }
            },
            possibleTypes: {
                GameNotification: ['MovePlayedNotification', 'MoveUndoneNotification']
            }
        })
    });
}
